/**
 * Convert Firestore Timestamp / Date / ISO strings to serializable ISO strings for Redux.
 */

export function firestoreValueToIso(value) {
  if (value == null) return null;
  if (typeof value.toDate === 'function') {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.toISOString();
  }
  if (typeof value === 'string') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    const d = new Date(value.seconds * 1000);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
  }
  return null;
}

/** Milliseconds since epoch from Firestore Timestamp / Date / ISO string, or null. */
export function firestoreValueToMillis(value) {
  if (value == null) return null;
  if (typeof value.toDate === 'function') {
    const t = value.toDate().getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (value instanceof Date) {
    const t = value.getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (typeof value === 'string') {
    const t = new Date(value).getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    return value.seconds * 1000;
  }
  return null;
}

const DEVICE_TIMESTAMP_KEYS = [
  'lastSeen',
  'last_seen',
  'timestamp',
  'created_at',
  'updated_at',
];

/**
 * Return a shallow copy of a device/map object with timestamp fields as ISO strings.
 */
export function normalizeDeviceTimestamps(device) {
  if (!device || typeof device !== 'object') return device;
  const out = { ...device };
  for (const key of DEVICE_TIMESTAMP_KEYS) {
    if (!(key in out) || out[key] == null) continue;
    const iso = firestoreValueToIso(out[key]);
    if (iso != null) out[key] = iso;
  }
  return out;
}

export function normalizeDevicesForRedux(devices) {
  if (!Array.isArray(devices)) return [];
  return devices.map(normalizeDeviceTimestamps);
}
